import { render, staticRenderFns } from "./CoreChangeLogTable.vue?vue&type=template&id=796a70bf&scoped=true"
import script from "./CoreChangeLogTable.vue?vue&type=script&lang=js"
export * from "./CoreChangeLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a70bf",
  null
  
)

export default component.exports